import { useEffect, useRef, useState } from "react";

/**
 * Sets a useState value only when the condition is met, otherwise value is stored in a ref
 * @param setStateCondition - Condition of when the useState is set
 */
export const useStateRenderOnCondition = <T>(setStateCondition: boolean): [T, (value: T) => void] => {
    const ref = useRef<T>(null);
    const [state, setState] = useState<T>();

    // Set both ref and useState if condition is met otherwise set just ref
    const onValueChange = (value: T) => {
        if (setStateCondition) {
            setState(value);
            ref.current = value;
        } else {
            ref.current = value;
        }
    };

    useEffect(() => {
        if (state !== ref.current) {
            onValueChange(ref.current);
        }
    }, [setStateCondition]);

    return [state, onValueChange];
};
